import type { FaireProductEntity } from "../../entity_types/product";

export const beverage_3: FaireProductEntity = {
  token: "beverage-3",
  type: "product",
  name: "Cold Brew Concentrate",
  brandName: "Craft Beverages",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/5014e60de379b84682b4e7ab84b3ebc84f56a11f4ed37efb6b78e49753b0514b.webp",
  priceDollars: 22,
  msrpDollars: 35,
  freeShipping: true,
  isBestseller: true,
  description: "",
  tags: [],
  inStock: true,
  categoryTokens: ["cat_food-drink"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
